import React, { useState, useEffect } from "react";
import styles from "./TextToPay.module.css";
import UTIL from "mroads-js-utils";
import FireboardUtils from "../../../../util/fireboard-util";
import TextInput from '../../../../components/TextInput';
import PopupHeader from "../PopupHeader";
import { CountryPicker, getPickerData } from "../../../../components/CountryPicker";

const US_COUNTRY_CODE = 'us';
const UK_COUNTRY_CODE = 'gb';

export default function TextToPay(props) {
  const { invokeTextToPay, selectedItem, fromFooter = false, meta, onClose, currency = '$', iso2 } = props;

  const [phoneNumber, setPhoneNumber] = useState(meta ? FireboardUtils.formattedPhoneNumber(meta.phoneNumber, iso2) : "");
  const [guestName, setGuestName] = useState(meta ? meta.deliverTo : "");
  const [pickupTime, setPickupTime] = useState(meta ? FireboardUtils.getTimeForPickup(meta.pickupDate) : "");
  const [checkNumber, setCheckNumber] = useState(meta ? meta.checkNumber.substr(1, meta.checkNumber.length - 2) : "");
  const [subTotal, setSubTotal] = useState(meta && meta.selectedCheckDetails ? meta.selectedCheckDetails.subTotalAmount : "");
  const [tax, setTax] = useState(meta && meta.selectedCheckDetails ? meta.selectedCheckDetails.taxAmount : "");
  const [selectedCountry, setSelectedCountry] = useState({});

  useEffect(() => {
    setDefaultCountry();
  }, []);

  const setDefaultCountry = () => {
    const countriesData = getPickerData();
    const countryCode = currency === '£' ? UK_COUNTRY_CODE : US_COUNTRY_CODE;
    const defaultCountry = countriesData.find(country => country.iso2 === countryCode);
    setSelectedCountry(defaultCountry);
  }

  const onCountryChange = country => {
    const formattedPhoneNumber = FireboardUtils.inputFormattedPhnNum(phoneNumber, country.iso2);
    setSelectedCountry(country);
    setPhoneNumber(formattedPhoneNumber);
  };

  useEffect(() => {
    if (Object.keys(selectedItem).length && !fromFooter) {
      const {
        selectedCheckDetails: {
          checkNumber,
          phoneNumber,
          pickupDate,
          taxAmount,
          guestName,
          subTotalAmount,
        },
      } = selectedItem || {};
      setPhoneNumber(!!phoneNumber ? FireboardUtils.formattedPhoneNumber(phoneNumber, iso2) : "");
      setGuestName(!!guestName ? guestName : "");
      setPickupTime(
        !!pickupDate ? FireboardUtils.getTimeForPickup(pickupDate) : ""
      );
      setCheckNumber(!!checkNumber ? checkNumber : "");
      setSubTotal(!!subTotalAmount ? subTotalAmount : "");
      setTax(!!taxAmount ? taxAmount : "");
    }

    return function cleanup() {
      reset();
    };
  }, [fromFooter, iso2, selectedItem]);

  const reset = () => {
    setPhoneNumber("");
    setGuestName("");
    setPickupTime("");
    setCheckNumber("");
    setSubTotal("");
    setTax("");
    setDefaultCountry();
  };

  const request = () => {
    invokeTextToPay &&
      invokeTextToPay({
        phoneNumber: phoneNumber,
        guestName: guestName,
        pickupTime: pickupTime,
        checkNumber: checkNumber,
        subTotal: subTotal,
        tax: tax,
        selectedCountry: selectedCountry,
      });
  };

  const changeTime = (time) => {
    const updatedTime = `${time}:00`;
    setPickupTime(updatedTime);
  };

  const disableCheckNumber = () => {
    return !!(props.selectedItem?.selectedCheckDetails?.checkNumber);
  }

  const disableSubTotal = () => {
    return !!(props.selectedItem?.selectedCheckDetails?.subTotalAmount);
  }

  const disableTax = () => {
    return !!(props.selectedItem?.selectedCheckDetails?.taxAmount);
  }

  const isDisabled = () => {
    if (phoneNumber.length > 0 && guestName.length > 0 && checkNumber.length > 0 && String(subTotal).length > 0 && String(tax).length > 0 && pickupTime.length >= 5) {
      return false;
    }
    return true;
  }

  const amtPattern = /^(?:\d*\.\d{1,2}|\d+)$/;

  const adjustSubTotal = amt => {
    if (amt === "") setSubTotal("");
    if (amt.match(amtPattern)) {
      setSubTotal(amt);
    }
  }

  const adjustTax = amt => {
    if (amt === "") setTax("");
    if (amt.match(amtPattern)) {
      setTax(amt);
    }
  }

  return (
    <div className={styles.container}>
      <PopupHeader title={"TEXT TO PAY"} onClose={onClose} containerStyle={styles.heading} />
      <div className={styles.container} >
        <div>
          <label className={styles.label}>Country Code</label>
          <CountryPicker selectedCountry={selectedCountry} onCountryChange={onCountryChange} />
        </div>
        <TextInput type="tel" placeholder="Phone Number" value={FireboardUtils.inputFormattedPhnNum(phoneNumber, selectedCountry.iso2)} onChange={val => setPhoneNumber(val)} inputStyle={styles.textInput} />
        <TextInput type="text" placeholder="Guest Name" value={guestName} onChange={val => setGuestName(val)} inputStyle={styles.textInput} />
        <TextInput type={'time'} placeholder="Pickup Time" value={pickupTime} onChange={val => changeTime(val)} inputStyle={styles.textInput} />
        <TextInput type="tel" placeholder="Check Number" disabled={disableCheckNumber()} value={checkNumber} onChange={val => setCheckNumber(val)} inputStyle={styles.textInput} />
        <TextInput type="number" placeholder="Subtotal Amount" disabled={disableSubTotal()} pattern="^\d*(\.\d{0,2})?$" value={subTotal} onChange={val => adjustSubTotal(val)} inputStyle={styles.textInput} />
        <TextInput type="number" placeholder="Tax Amount" disabled={disableTax()} value={tax} onChange={val => adjustTax(val)} inputStyle={styles.textInput} />
      </div>
      <div className={styles.btnWrapper}>
        <button className={styles.btns} onClick={reset}>RESET</button>
        <button className={styles.btns} onClick={request} disabled={isDisabled()} style={{ opacity: isDisabled() ? 0.4 : 1 }}>REQUEST</button>
      </div>
    </div>
  );
};
